import { render } from "./ScDataTableReports.vue?vue&type=template&id=4b3c6143"
import script from "./ScDataTableReports.vue?vue&type=script&lang=js"
export * from "./ScDataTableReports.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/bezbedno/admin/static/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"js/Reports/ScDataTableReports.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4b3c6143"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4b3c6143', __exports__)) {
    console.log('reload')
    api.reload('4b3c6143', __exports__)
  }
  
  module.hot.accept("./ScDataTableReports.vue?vue&type=template&id=4b3c6143", () => {
    console.log('re-render')
    api.rerender('4b3c6143', render)
  })

}


export default __exports__